module.exports = __webpack_public_path__ + "img/tu_2.515c1915.png";